import { toast } from 'react-toastify';

export const showErrorToast = (id, message) => {
  toast(message, {
    toastId: id,
    type: 'error',
    theme: 'dark',
    position: 'top-left',
  });
};

export const showSuccessToast = (id, message) => {
  toast(message, {
    toastId: id,
    type: 'success',
    theme: 'dark',
    position: 'top-left',
  });
};